<template>
  <div>
    <div class="fw-bold py-2">
      Шаг 1 из {{ fl ? "5" : "8" }} Общие сведения об
      организации-лизингополучателе
    </div>

    <Step1 :data="data" :fl="fl" :errors="errors" :disabled="disabled" />

    <div v-if="!fl">
      <div size="2" class="hr"></div>
      <div class="fw-bold py-2">Шаг 2 из 8 Сведения об учредителях</div>

      <Step2 :data="data" :errors="errors" :disabled="disabled" />

      <div size="2" class="hr"></div>
      <div class="fw-bold py-2">
        Шаг 3 из 8 Сведения о бенефициарных владельцах, которые не являются
        учредителями
      </div>

      <Step3 :data="data" :errors="errors" :disabled="disabled" />

      <!-- <div size="2" class="hr"></div>
            <div class="fw-bold py-2">Шаг 4 из 7 Виды деятельности лизингополучателя</div>

            <Step4 /> -->
    </div>

    <div size="2" class="hr mt-3"></div>
    <div class="fw-bold py-2">
      Шаг {{ fl ? "2" : "4" }} из {{ fl ? "5" : "8" }} Основные контрагенты
      лизингополучателя
    </div>

    <Step5 :data="data" :errors="errors" :disabled="disabled" />

    <div size="2" class="hr mt-3"></div>
    <div class="fw-bold py-2">
      Шаг {{ fl ? "3" : "5" }} из {{ fl ? "5" : "8" }} Информация о кредитах и
      займах в т.ч от учредителей
    </div>

    <Step6 :data="data" :errors="errors" :disabled="disabled" />

    <div size="2" class="hr mt-3"></div>
    <div class="fw-bold py-2">
      Шаг {{ fl ? "4" : "6" }} из {{ fl ? "5" : "8" }} Cведения о договорах
      лизинга
    </div>

    <Step7 :data="data" :errors="errors" :disabled="disabled" />

    <div size="2" class="hr mt-3"></div>
    <div class="fw-bold py-2">
      Шаг {{ fl ? "5" : "7" }} из {{ fl ? "5" : "8" }} Сведения об открытых
      банковских счетах лизингополучателя
    </div>

    <Step8 :data="data" :errors="errors" :disabled="disabled" />

    <div v-if="!fl">
      <div size="2" class="hr mt-3"></div>
      <div class="fw-bold py-2">Шаг 8 из 8 Оператор ЭДО</div>

      <StepEdo :data="data" :errors="errors" :disabled="disabled" />
    </div>

    <div class="page-title">Подпись</div>
    <div size="2" class="hr mb-3"></div>
    <div>
      Продолжая использовать сервис, я соглашаюсь с
      <a href="https://www.stone-xxi.ru/terms-of-use/" target="_blank"
        >Правилами пользования</a
      >
      и
      <a href="https://www.stone-xxi.ru/privacy-policy/" target="_blank"
        >Политикой конфиденциальности и обработки персональных данных</a
      >
    </div>

    <Sign
      :phone="data.SignerPhone"
      :inn="data.LPINN"
      :getFile="getFile"
      title="STONE-XXI - Анкета лизингополучателя"
      :show="['print', 'fns', 'nopaper']"
      default="fns"
      :uid="props.uid"
      :status="status"
      :continueTo="'/leasings/' + route.params.id"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { postApi, formatDate } from "../../../run";

import { useStore } from "vuex";
const store = useStore();

import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
// import Step4 from './Step4.vue'
import Step5 from "./Step5.vue";
import Step6 from "./Step6.vue";
import Step7 from "./Step7.vue";
import Step8 from "./Step8.vue";
import StepEdo from "./StepEdo.vue";

import Sign from "../../../component/sign/index.vue";

import { useRoute } from "vue-router";
const route = useRoute();

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  uid: {
    type: String,
  },
  status: {
    type: Number,
  },
});

// const fl = ref(false);

const fl = computed(() => data.value.LPINN.length === 12);

const errors = ref({});

const data = ref({ ...props.data });

const disabled = computed(() => props.status > 0);
// const typeSign = computed(() =>
//   store.state.main.typeSign ? store.state.main.typeSign : "fns"
// );

let stopWatch = null;
let saveTimeout = null;

const getFile = async () => {
  errors.value = {};
  return await postApi("/fileAnketa", {
    data: JSON.stringify(data.value),
  }).then((res) => {
    if (res.error) {
      errors.value = res.errors ? res.errors : {};
      return res;
    } else {
      return res.base64File;
    }
  });
};

const isInitialized = ref(false);

const saveDataToServer = () => {
  postApi("/save", {
    data: JSON.stringify(data.value),
    UID: props.uid,
  });
};

onMounted(() => {
  data.value.sendLink = data.value?.sendLink
    ? data.value.sendLink
    : data.value.LPEmail;
  stopWatch = watch(
    data.value,
    () => {
      if (isInitialized.value) {
        if (saveTimeout) clearTimeout(saveTimeout);
        saveTimeout = setTimeout(() => {
          saveDataToServer();
        }, 1000);
      }
    },
    { deep: true, immediate: true }
  );

  setTimeout(() => {
    isInitialized.value = true;
  }, 1000);
});

onUnmounted(() => {
  if (stopWatch) {
    stopWatch();
  }
});
</script>